import React from 'react';

import { TrackerObjectiveValueTypes } from 'constants/assignments';

import Icons from 'pages/Teachers/Assignments/Feedback/components/RightMenu/Icons';

const CheckGradeIcon = ({ grade, objectiveValueType }) => {
  if (objectiveValueType !== TrackerObjectiveValueTypes.CHECK_GRADE)
    return null;

  switch (grade) {
    case 1:
      return <Icons.CheckPlus fontSize="small" />;
    case 0:
      return <Icons.Check fontSize="small" />;
    case -1:
      return <Icons.CheckMinus fontSize="small" />;
    default:
      return null;
  }
};

export default CheckGradeIcon;
